import React from 'react';
import { Layout, Button, Typography, Space, Avatar, Dropdown, Tag, Tooltip } from 'antd';
import { useNavigate } from 'react-router-dom';
import { User, LogOut, Menu as MenuIcon, Clock, UserCircle } from 'lucide-react';

const { Header } = Layout;
const { Text } = Typography;

const AppHeader = ({ user, onLogout, sessionGraceLabel, mobileOpen, setMobileOpen, config }) => {
    const navigate = useNavigate();

    const userMenu = {
        items: [
            {
                key: 'profile',
                label: 'My Profile',
                icon: <UserCircle size={16} />,
                onClick: () => navigate('/profile')
            },
            {
                type: 'divider'
            },
            {
                key: 'logout',
                label: 'Logout',
                icon: <LogOut size={16} />,
                danger: true,
                onClick: onLogout
            }
        ]
    };

    return (
        <Header style={{
            padding: '0 24px',
            background: '#fff',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            boxShadow: '0 1px 4px rgba(0,21,41,0.08)',
            position: 'sticky',
            top: 0,
            zIndex: 99,
            height: 64
        }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
                {/* Mobile Menu Button */}
                <Button
                    onClick={() => setMobileOpen(!mobileOpen)}
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: 40,
                        height: 40,
                        padding: 0,
                        border: 'none', // Ensure no border affects box model
                    }}
                    className="mobile-menu-btn"
                >
                    <MenuIcon size={20} />
                </Button>

                {/* Branding */}
                <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                    <img src="/spatium-logo.png" alt="Spatium Logo" style={{ height: 32, objectFit: 'contain' }} />
                    <Tag color="geekblue" style={{ margin: 0, fontSize: '0.9rem', padding: '4px 12px' }}>
                        {config?.companyName || 'Spatium Hub'}
                    </Tag>
                </div>
            </div>

            <Space size={24} align="center" className="desktop-only">
                {sessionGraceLabel && (
                    <Tooltip
                        title="Your session will automatically reset after this time. Any unsaved changes will be lost. Stay active to extend your session."
                        placement="bottomRight"
                    >
                        <Text type="secondary" style={{ fontSize: 13, cursor: 'help' }}>
                            Session: <Text strong style={{ color: '#1677ff', fontSize: 13 }}>{sessionGraceLabel}</Text>
                        </Text>
                    </Tooltip>
                )}

                {user && (
                    <Dropdown menu={userMenu} placement="bottomRight" arrow>
                        <Space style={{ cursor: 'pointer', padding: '4px 8px', borderRadius: 6, transition: 'background 0.3s' }} className="user-header-profile">
                            <Avatar
                                style={{ backgroundColor: '#667eea', verticalAlign: 'middle' }}
                                icon={<User size={18} />}
                            />
                            <div style={{ display: 'flex', flexDirection: 'column', lineHeight: 1.2 }}>
                                <Text strong style={{ fontSize: 14 }}>{user.name}</Text>
                                <Text type="secondary" style={{ fontSize: 11 }}>{user.role === 'admin' ? 'Administrator' : user.role === 'viewer' ? 'Viewer (read-only)' : 'User'}</Text>
                            </div>
                        </Space>
                    </Dropdown>
                )}
            </Space>
        </Header>
    );
};

export default AppHeader;
